import { TypedDocumentNode, gql } from "@apollo/client";

interface FaqsData {
  faqs: FaqsInterface[];
}

export enum FaqType {
  GENERAL = "FAQ_GENERAL",
  COURSES = "FAQ_COURSES",
  PAYMENT = "FAQ_PAYMENT",
  CONSULTING = "FAQ_CONSULTING",
}

type FaqsParams = {
  faqType?: FaqType;
  slug?: string;
  country?: string;
  city?: string;
};

export const GET_FAQS: TypedDocumentNode<FaqsData, FaqsParams> = gql`
  query GetFaqs(
    $faqType: FaqType
    $slug: String
    $country: String
    $city: String
  ) {
    faqs(
      faqType: $faqType
      pageSlug: $slug
      countryCode: $country
      citySlug: $city
    ) {
      id
      question
      answer
    }
  }
`;
